import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import Select from "react-select";
import { AccountManagementContext } from "../../../../context/AccountManagementContext";
import { AddAssignRole, getAssignRoleListByID } from "../../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
import notify from "../../../../utils/notification";
import swal from "sweetalert";
export default function AssignUsersModal({ debouncedSearchValue, currentPage, perPage, roleId, show, handleClose }) {

    const [search, setSearch] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [roleDetails, setRoleDetails] = useState([]);

    const { loading, userAccountList, fetchUserAccountManagementList, fetchRoleAccountManagementList, fetchDeleteAccountuser } =
        useContext(AccountManagementContext);
    const handleAssign = async () => {
        try {
            const userIds = selectedUsers.map(user => user.value);

            const payload = {
                user_ids: userIds
            };

            // Call API first
            const response = await AddAssignRole(roleId, payload);

            // Check success condition
            if (response?.status === 200 || response?.data?.status === true) {
                swal("Success", response?.data?.message || "Users Assigned Successfully", "success");
                await fetchRoleAccountManagementList( 
                     "",
                    "desc",
                    debouncedSearchValue,
                    perPage,
                    1,
                );
                handleClose();
                setSelectedUsers([]);

            } else {
                notify("error", response?.data?.message || "Something went wrong");
            }

        } catch (error) {
            notify(
                "error",
                error?.response?.data?.message || "Something went wrong"
            );
            console.log(error);
        }
    }




    const fetchRoleDetails = async (roleId) => {
        if (!roleId) return;

        try {
            const res = await getAssignRoleListByID(roleId);

            if (res?.data?.status) {
                const roleData = res.data.data;

                setRoleDetails(roleData);

                //   if (roleData?.assigned_users?.length > 0) {
                //     const preSelectedUsers = roleData.assigned_users.map(user => ({
                //       label: user.name,
                //       value: user.id
                //     }));

                //     setSelectedUsers(preSelectedUsers);
                //   } else {
                //     setSelectedUsers([]);
                //   }

                setSelectedUsers([]);
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        if (show && roleId) {
            fetchRoleDetails(roleId);
        }
    }, [show, roleId]);


    const userOptions =
        roleDetails?.available_users?.map(user => ({
            label: user.display_label,
            value: user.id,

        })) || [];


    return (
        <Modal show={show} onHide={handleClose} centered size="md">
            <Modal.Body className="p-4">

                <div className="mb-5">
                    {/* Header */}
                    <h5 className="fw-bold mb-4">Assign Users</h5>

                    {/* Role + Description */}
                    <Row className="mb-3 mx-1">
                        <Col xs={4} className="text-muted">Role :</Col>
                        <Col xs={8}>{roleDetails?.role_name}</Col>
                    </Row>

                    <Row className="mb-3 mx-1">
                        <Col xs={4} className="text-muted">Description :</Col>
                        <Col xs={8}
                            style={{
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal"
                            }}
                        >
                            {roleDetails?.description?.length > 200
                                ? roleDetails.description.slice(0, 200) + "...."
                                : roleDetails?.description}
                        </Col>
                    </Row>
                    <h5 className=" mb-4"> Users</h5>
                    <Row className="mb-3">
                        <Col xs={10} className="text-muted">
                            <Select
                                options={userOptions}
                                isMulti
                                placeholder="Search & Select Users"
                                value={selectedUsers}
                                onChange={setSelectedUsers}

                            /></Col>

                    </Row>


                </div>



                {/* Footer Buttons */}
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <Button border onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleAssign}
                        disabled={!selectedUsers.length}
                    >
                        Assign
                    </Button>
                </div>

            </Modal.Body>
        </Modal>
    );
}
